const es = {
  api: {
    non_field_errors: 'error',
    tax_id: 'número fiscal',
    invoice: 'factura {number}',
    lines: 'líneas',
    name: 'nombre',
    discount_scheme: 'tipo de descuento',
    amount: 'monto',
    customer: 'cliente',
    document: 'documento',
    next_number: 'número siguiente',
    date: 'fecha',
    due_date: 'fecha de pago',
    payments: 'pagos',
    file: 'archivo',
    logo: 'logo',
    month: 'Mensual',
    year: 'Anual',
    monthly: 'Mensual',
    yearly: 'Anual',
    daily: 'Diario',
    this_v_last: 'actual vs último',
    this_v_last_mtd: 'actual vs último (MTD)',
    last_v_one_before: 'último vs antepenúltimo',
    tax_agency_failed: 'Facturación fallida',

    // subscription errors
    without_usage_records: 'Al menos un plan en esta suscripción no tiene consumo registrado en el ciclo de facturación actual',
    biller_issue: 'Ha ocurrido un error en el procesador de facturación al intentar crear la factura',
    gateway_issue: 'Ha ocurrido un error en el procesador de pagos al intentar realizar el cargo en la tarjeta del cliente',
    reference_expired: 'La suscripción no tiene referencia o se encuentra expirada',
    processing_issue: 'Ha ocurrido un error desconocido en el procesamiento de la suscripción',
    without_reference: 'La suscripción no tiene una referencia asociada',
    intent_not_allowed: 'No se permiten más intentos de cobro para esta suscripción',
    invoice_failed_payment_succeeded: 'El pago se realizó correctamente, pero la factura no pudo emitirse. Se reintentará automáticamente.',

    // payments status_detail
    card_blocked: 'Tarjeta bloqueada',
    card_expired: 'Tarjeta expirada',
    card_invalid: 'Tarjeta inválida',
    card_not_found: 'Tarjeta no encontrada por el emisor',
    charge_error: 'Error al intentar el cargo',
    charge_max_amount_exceeded: 'Monto del cargo supera el máximo permitido para la tarjeta',
    charge_not_supported: 'Cargo no permitido por el banco',
    charge_rejected: 'Cargo rechazado por el banco',
    max_retries_exceeded: 'Se alcanzó el máximo de reintentos permitidos por el emisor',
    not_specified: 'No especificado por el procesador de pagos',
    provider_authentication_failed: 'Autenticación fallida con el procesador de pagos',
    provider_connection_failed: 'Conexión fallida con el procesador de pagos',
    rejection_by_data: 'Cargo rechazado por inconsistencia de información',
    rejection_by_fraud_control: 'Cargo rechazado por control de fraude',
    rejection_by_issuing: 'Cargo rechazado por el emisor de la tarjeta',
    source_gateway_daily_max_amount_exceeded: 'Se ha excedido el monto máximo diario del procesador de pagos',
    source_gateway_max_amount_exceeded: 'Se ha excedido el monto máximo del procesador de pagos',
    source_gateway_max_payments_exceeded: 'Se ha excedido la cantidad máxima de pagos del procesador de pagos'
  },
  metrics: {
    net_growth_arr: 'Crecimiento neto del ARR',
    total_arr: 'Total del ARR',
    expansion_arr: 'Expansión del ARR',
    new_arr: 'Nuevo ARR',
    contraction_arr: 'Contracción del ARR',
    churn_arr: 'Cancelación del ARR',
    total_mrr: 'Total del MRR',
    expansion_mrr: 'Expansión del MRR',
    new_mrr: 'Nuevo MRR',
    contraction_mrr: 'Contracción del MRR',
    churn_mrr: 'Cancelación del MRR',
    total_billing: 'Facturación total',
    total_tax: 'Impuestos totales',
    net_growth_mrr: 'Crecimiento neto del MRR',
    arpu: 'Ingresos promedio por suscripción',
    churn_count_mrr: 'Cancelación de suscripciones',
    total_billing_non_recurring: 'Facturación total no recurrente',
    net_billing: 'Facturación neta',
    total_cancelled_subscription: 'Cancelación de suscripciones',
    rate_cancelled_subscription: 'Tasa de abandono de la suscripción',
    total_cancelled_billing: 'Total de la facturación anulada',
    total_receivables: 'Cuentas por cobrar',
    total_receivables_overdue: 'Cuentas por cobrar: vencidas',
    total_receivables_current_due: 'Cuentas por cobrar: por vencer',
    overdue_billing_recovery_breakdown: 'Antigüedad de cuentas por cobrar',
    customer_debtor: 'Principales deudores',
    '1_to_14': '1 a 14 días',
    '15_to_29': '15 a 29 días',
    '30_to_59': '30 a 59 días',
    more_than_60: 'más de 60 días',
    total_payments: 'Transacciones recibidas',
    transactions_received_by_gateway: 'Transacciones recibidas por procesador de pagos',
    'unused-supporting-documents': 'Documentos de soporte no utilizados',
    'expired-supporting-documents': 'Documentos de soporte expirados',
    'unprocessed-subscriptions': 'Suscripciones no procesadas'
  },
  ach_transfer: 'Transferencia',
  balance: 'Pendiente',
  customer: 'Cliente',
  current: 'Total',
  getnet: 'Getnet',
  getnetclick: 'Getnet Click',
  offline_payment: 'Pago externo',
  oneclick: 'Webpay Oneclick',
  payment_date: 'Fecha de pago',
  stripe: 'Stripe',
  webpay: 'Webpay'
}

export default {
  es
}
